import {fetchStores} from "../util/fetch-stores";
import type {
  Geolocation,
  LasConfigType,
  FetchStoresOptions,
  BopisStorageType,
} from "../types/bopis";
import type {BopisStorageInterfaceType} from "../providers/bopis-storage";

type GetBopisDataProps = {
  bopisStorage: BopisStorageInterfaceType;
  lasConfig: LasConfigType;
  geoLocationData: Geolocation;
  options: FetchStoresOptions;
};

export const getBopisData = async ({
  bopisStorage,
  lasConfig,
  geoLocationData,
  options = {},
}: GetBopisDataProps): Promise<Omit<BopisStorageType, "expiration">> => {
  let bopisData = {
    enabled: bopisStorage.get("enabled") || false,
  };
  // get stores (with personalization data)
  const {postalCode, latitude, longitude} = geoLocationData;
  bopisData = await fetchStores(
    bopisStorage,
    postalCode,
    latitude,
    longitude,
    options,
    lasConfig,
    false
  );

  return bopisData;
};
